<script setup lang="ts">
import CircleCloseIcon from '@/assets/icons/shared/circle/close.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
</script>

<template>
  <UiButton color="white">
    <CircleCloseIcon v-prefix />
    <span>{{ $t('ui.common.button.close') }}</span>
  </UiButton>
</template>
